<template>
  <div>
    <!-- Reporte 1 · Ventas, crecimiento y ticket -->
    <exec-report-panel report-name="sales" title="Ventas y ticket" :filters="filters" @error="$emit('error', $event)" />
    <!-- Reporte 2 · Venta y participación por canal -->
    <div class="mt-4">
      <exec-report-panel report-name="channel-mix" title="Participación por canal" :filters="filters" @error="$emit('error', $event)" />
    </div>
  </div>
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 2 · Ventas y rentabilidad (doc 04 §3, reportes 1 y 2).
export default { name: 'ExecSales', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
